import React from 'react';
import UploadForm from './UploadForm';

interface UploadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UploadModal: React.FC<UploadModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div 
        className="fixed inset-0 bg-black/60 dark:bg-black/70 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      <div className="flex min-h-full items-center justify-center p-3">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-slate-800 shadow-2xl transition-all animate-fade-in">
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-slate-700 px-4 py-3">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Upload License Plates
            </h2>
            <button
              onClick={onClose}
              className="rounded-xl p-2 text-gray-400 dark:text-slate-500 hover:bg-gray-100 dark:hover:bg-slate-700 hover:text-gray-600 dark:hover:text-slate-300 transition-colors"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="px-4 py-3">
            <UploadForm onSuccess={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
